/* Component in ScenePage to display the Scene data
 * Contains the CharactersBG, Breakdown, Script, ShotlistPage,
   Storyboard, WorkspaceGuideForm and WorkspaceGuideEdit components 
   each of which deals with a section of the Scene data
   studio workshop  */
import React, { useState } from "react";

import { useHistory } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Button } from "react-bootstrap";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import {
  useSetCategoryContext,
  useSetDeptContext,
  useSetNumberContext,
  useSetSceneContext,
} from "../../contexts/DeptCategoryContext";
import sceneblue6 from "../../assets/sceneblue6.png";
import sceneblue8 from "../../assets/sceneblue8.png";
import newpur from "../../assets/newpur.jpg"
import newpur9 from "../../assets/newpur9.jpg"
import { PostDropAdminOnly } from "../../components/PostDropdown";
import ShotlistPage from "./shotlistStoryboard/ShotlistPage";
import WorkspaceGuideForm from "./WorkspaceGuideForm";
import WorkspaceGuideEdit from "./WorkspaceGuideEdit";
import Breakdown from "./breakdown/Breakdown";
import TopBox from "../../components/TopBox";
import InfoScenePage from "./info/InfoScenePage";
import InfoWorkspace from "./info/InfoWorkspace";
import CharactersBG from "./charactersBg/CharactersBG";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";

import styles from "../../styles/Scene.module.css";
import btnStyles from "../../styles/Button.module.css";
import StoryboardforSList from "./shotlistStoryboard/StoryboardforSList";
import toast from "react-hot-toast";

const Scene = (props) => {
  const host = useHostName();
  const currentUser = useCurrentUser();
  const [showlist, setShowlist] = useState(false);
  const [showBreak, setShowBreak] = useState(false);
  const [showCharactersBG, setShowCharactersBG] = useState(false);
  const [showStoryShot, setShowStoryShot] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const [showGuideEdit, setShowGuideEdit] = useState(false);
  const setSceneId = useSetSceneContext();
  const setNumber = useSetNumberContext();
  const setDept = useSetDeptContext();
  const setCategory = useSetCategoryContext();
  const {
    id,
    number,
    storyboard,
    workspace_guide,
    posts,
    scene,
    setScene,
    episodeTitle,
    pro,
    epi,
  } = props;
  const history = useHistory();
  const [showInfo, setShowInfo] = useState(false);
  const [showWorkInfo, setShowWorkInfo] = useState(false);

  const handleEdit = () => {
    history.push(
      `/${localStorage.getItem("projectSlug")}/scenes/${id}/edit${
        epi && pro && episodeTitle
          ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
          : ""
      }`
    );
  };

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/scenes/${id}/`);
        toast.success(`Scene Deleted`);
        history.goBack();
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/scenes/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        toast.success(`Scene Deleted Successfully!`);
        history.goBack();
      }
    } catch (err) {}
  };

  const handleClickCameraReq = () => {
        setSceneId(id); 
        setNumber(number);
        setDept("camera");
        setCategory("requirements");
        history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
      };

      const handleClickCameraWor = () => {
        setSceneId(id); 
        setNumber(number);
        setDept("camera");
        setCategory("workspace");
        history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
      };

      const handleClickCameraFin = () => {
        setSceneId(id); 
        setNumber(number);
        setDept("camera");
        setCategory("finals");
        history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
      };

    const handleClickSoundReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("sound");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickSoundWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("sound");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickSoundFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("sound");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          ); 
    };

    const handleClickLocationReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("location");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickLocationWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("location");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickLocationFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("location");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };
    
    const handleClickScriptReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("script");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickScriptWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("script");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickScriptFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("script");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickArtReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("art");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickArtWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("art");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickArtFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("art");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickMakeupReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("make-up");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickMakeupWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("make-up");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          ); 
    };

    const handleClickMakeupFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("make-up");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickWardrobeReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("wardrobe");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickWardrobeWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("wardrobe");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          ); 
    };

    const handleClickWardrobeFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("wardrobe");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickCastingReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("casting");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickCastingWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("casting");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          ); 
    };

    const handleClickCastingFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("casting");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickPostReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("post");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickPostWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("post");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          ); 
    };

    const handleClickPostFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("post");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickProductionReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("production");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickProductionWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("production");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickProductionFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("production");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );
    };

    const handleClickStuntsReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("stunts");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickStuntsWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("stunts");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          ); 
    };

    const handleClickStuntsFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("stunts");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickElectricReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("electric");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          ); 
    };

    const handleClickElectricWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("electric");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          ); 
    };

    const handleClickElectricFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("electric");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickUniversalReq = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("universal");
      setCategory("requirements");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

    const handleClickUniversalWor = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("universal");
      setCategory("workspace");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          ); 
    };

    const handleClickUniversalFin = () => {
      setSceneId(id); 
      setNumber(number);
      setDept("universal");
      setCategory("finals");
      history.push(
            `/${localStorage.getItem("projectSlug")}/dept/category${
              epi && pro && episodeTitle
                ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
                : ""
            }`
          );  
    };

  const handleClickMoods = () => {
    /* Function to open the Scene MoodBoards page
       * Sets the SceneId and Number in App.js for /scene/moodshots Route */
    setSceneId(id);
    setNumber(number);
    history.push(
      `/${localStorage.getItem("projectSlug")}/scene/moodshots${
        epi && pro && episodeTitle
          ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
          : ""
      }`
    );
  };

  const clickScript = () => {
    /* Function to open the Scene Script page
       * Sets the SceneId context in App.js for /script/scene/${id} Route */
    setSceneId(id);
    history.push(
      `/${localStorage.getItem("projectSlug")}/script/scene/${id}${
        epi && pro && episodeTitle
          ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
          : ""
      }`
    );
  };

  const clickStory = () => {
    setSceneId(id);
    history.push(
      `/${localStorage.getItem("projectSlug")}/story/scene/${id}${
        epi && pro && episodeTitle
          ? `?episode=${epi}&project=${pro}&episodeTitle=${episodeTitle}`
          : ""
      }`
    );
  };

  /* Functions to get departments total posts  */

        // CAMERA
        const camReqUnopen = posts.filter(post => post.departments === "camera" 
          && post.category === "requirements" && post.opened_id === null).length;

        const camWorkUnopen = posts.filter(post => post.departments === "camera" 
          && post.category === "workspace" && post.opened_id === null).length;

        const camFinUnopen = posts.filter(post => post.departments === "camera" 
          && post.category === "finals" && post.opened_id === null).length;

        const camReqOpen = posts.filter(post => post.departments === "camera" 
          && post.category === "requirements" && post.opened_id).length;

        const camWorkOpen = posts.filter(post => post.departments === "camera" 
          && post.category === "workspace" && post.opened_id).length;

        const camFinOpen = posts.filter(post => post.departments === "camera" 
          && post.category === "finals" && post.opened_id).length;

        // SOUND
        const souReqUnopen = posts.filter(post => post.departments === "sound" 
          && post.category === "requirements" && post.opened_id === null).length;

        const souWorkUnopen = posts.filter(post => post.departments === "sound" 
          && post.category === "workspace" && post.opened_id === null).length;

        const souFinUnopen = posts.filter(post => post.departments === "sound" 
          && post.category === "finals" && post.opened_id === null).length;

        const souReqOpen = posts.filter(post => post.departments === "sound" 
          && post.category === "requirements" && post.opened_id).length;

        const souWorkOpen = posts.filter(post => post.departments === "sound" 
          && post.category === "workspace" && post.opened_id).length;

        const souFinOpen = posts.filter(post => post.departments === "sound" 
          && post.category === "finals" && post.opened_id).length;

        // LOCATION
        const locReqUnopen = posts.filter(post => post.departments === "location" 
          && post.category === "requirements" && post.opened_id === null).length;

        const locWorkUnopen = posts.filter(post => post.departments === "location" 
          && post.category === "workspace" && post.opened_id === null).length;

        const locFinUnopen = posts.filter(post => post.departments === "location" 
          && post.category === "finals" && post.opened_id === null).length;

        const locReqOpen = posts.filter(post => post.departments === "location" 
          && post.category === "requirements" && post.opened_id).length;

        const locWorkOpen = posts.filter(post => post.departments === "location" 
          && post.category === "workspace" && post.opened_id).length;

        const locFinOpen = posts.filter(post => post.departments === "location" 
          && post.category === "finals" && post.opened_id).length;

          // SCRIPT
          const scrReqUnopen = posts.filter(post => post.departments === "script" 
            && post.category === "requirements" && post.opened_id === null).length;
  
          const scrWorkUnopen = posts.filter(post => post.departments === "script" 
            && post.category === "workspace" && post.opened_id === null).length;
  
          const scrFinUnopen = posts.filter(post => post.departments === "script" 
            && post.category === "finals" && post.opened_id === null).length;
  
          const scrReqOpen = posts.filter(post => post.departments === "script" 
            && post.category === "requirements" && post.opened_id).length;
  
          const scrWorkOpen = posts.filter(post => post.departments === "script" 
            && post.category === "workspace" && post.opened_id).length;
  
          const scrFinOpen = posts.filter(post => post.departments === "script" 
            && post.category === "finals" && post.opened_id).length;

          // ART
          const artReqUnopen = posts.filter(post => post.departments === "art" 
            && post.category === "requirements" && post.opened_id === null).length;
  
          const artWorkUnopen = posts.filter(post => post.departments === "art" 
            && post.category === "workspace" && post.opened_id === null).length;
  
          const artFinUnopen = posts.filter(post => post.departments === "art" 
            && post.category === "finals" && post.opened_id === null).length;
  
          const artReqOpen = posts.filter(post => post.departments === "art" 
            && post.category === "requirements" && post.opened_id).length;
  
          const artWorkOpen = posts.filter(post => post.departments === "art" 
            && post.category === "workspace" && post.opened_id).length;
  
          const artFinOpen = posts.filter(post => post.departments === "art" 
            && post.category === "finals" && post.opened_id).length;

          // makeup
          const makReqUnopen = posts.filter(post => post.departments === "make-up" 
            && post.category === "requirements" && post.opened_id === null).length;
  
          const makWorkUnopen = posts.filter(post => post.departments === "make-up" 
            && post.category === "workspace" && post.opened_id === null).length;
  
          const makFinUnopen = posts.filter(post => post.departments === "make-up" 
            && post.category === "finals" && post.opened_id === null).length;
  
          const makReqOpen = posts.filter(post => post.departments === "make-up" 
            && post.category === "requirements" && post.opened_id).length;
  
          const makWorkOpen = posts.filter(post => post.departments === "make-up" 
            && post.category === "workspace" && post.opened_id).length;
  
          const makFinOpen = posts.filter(post => post.departments === "make-up" 
            && post.category === "finals" && post.opened_id).length;

          // COSTUME
          const warReqUnopen = posts.filter(post => post.departments === "wardrobe" 
            && post.category === "requirements" && post.opened_id === null).length;
  
          const warWorkUnopen = posts.filter(post => post.departments === "wardrobe" 
            && post.category === "workspace" && post.opened_id === null).length;
  
          const warFinUnopen = posts.filter(post => post.departments === "wardrobe" 
            && post.category === "finals" && post.opened_id === null).length;
  
          const warReqOpen = posts.filter(post => post.departments === "wardrobe" 
            && post.category === "requirements" && post.opened_id).length;
  
          const warWorkOpen = posts.filter(post => post.departments === "wardrobe" 
            && post.category === "workspace" && post.opened_id).length;
  
          const warFinOpen = posts.filter(post => post.departments === "wardrobe" 
            && post.category === "finals" && post.opened_id).length;

          // CASTING
          const casReqUnopen = posts.filter(post => post.departments === "casting" 
            && post.category === "requirements" && post.opened_id === null).length;
  
          const casWorkUnopen = posts.filter(post => post.departments === "casting" 
            && post.category === "workspace" && post.opened_id === null).length;
  
          const casFinUnopen = posts.filter(post => post.departments === "casting" 
            && post.category === "finals" && post.opened_id === null).length;
  
          const casReqOpen = posts.filter(post => post.departments === "casting" 
            && post.category === "requirements" && post.opened_id).length;
  
          const casWorkOpen = posts.filter(post => post.departments === "casting" 
            && post.category === "workspace" && post.opened_id).length;
  
          const casFinOpen = posts.filter(post => post.departments === "casting" 
            && post.category === "finals" && post.opened_id).length;

          // CASTING
          const posReqUnopen = posts.filter(post => post.departments === "post" 
            && post.category === "requirements" && post.opened_id === null).length;
  
          const posWorkUnopen = posts.filter(post => post.departments === "post" 
            && post.category === "workspace" && post.opened_id === null).length;
  
          const posFinUnopen = posts.filter(post => post.departments === "post" 
            && post.category === "finals" && post.opened_id === null).length;
  
          const posReqOpen = posts.filter(post => post.departments === "post" 
            && post.category === "requirements" && post.opened_id).length;
  
          const posWorkOpen = posts.filter(post => post.departments === "post" 
            && post.category === "workspace" && post.opened_id).length;
  
          const posFinOpen = posts.filter(post => post.departments === "post" 
            && post.category === "finals" && post.opened_id).length;

          // PRODUCTION
          const proReqUnopen = posts.filter(post => post.departments === "production" 
            && post.category === "requirements" && post.opened_id === null).length;
  
          const proWorkUnopen = posts.filter(post => post.departments === "production" 
            && post.category === "workspace" && post.opened_id === null).length;
  
          const proFinUnopen = posts.filter(post => post.departments === "production" 
            && post.category === "finals" && post.opened_id === null).length;
  
          const proReqOpen = posts.filter(post => post.departments === "production" 
            && post.category === "requirements" && post.opened_id).length;
  
          const proWorkOpen = posts.filter(post => post.departments === "production" 
            && post.category === "workspace" && post.opened_id).length;
  
          const proFinOpen = posts.filter(post => post.departments === "production" 
            && post.category === "finals" && post.opened_id).length;

          // STUNTS
          const stuReqUnopen = posts.filter(post => post.departments === "stunts" 
            && post.category === "requirements" && post.opened_id === null).length;
  
          const stuWorkUnopen = posts.filter(post => post.departments === "stunts" 
            && post.category === "workspace" && post.opened_id === null).length;
  
          const stuFinUnopen = posts.filter(post => post.departments === "stunts" 
            && post.category === "finals" && post.opened_id === null).length;
  
          const stuReqOpen = posts.filter(post => post.departments === "stunts" 
            && post.category === "requirements" && post.opened_id).length;
  
          const stuWorkOpen = posts.filter(post => post.departments === "stunts" 
            && post.category === "workspace" && post.opened_id).length;
  
          const stuFinOpen = posts.filter(post => post.departments === "stunts" 
            && post.category === "finals" && post.opened_id).length;

          // ELECTRIC
          const eleReqUnopen = posts.filter(post => post.departments === "electric" 
            && post.category === "requirements" && post.opened_id === null).length;
  
          const eleWorkUnopen = posts.filter(post => post.departments === "electric" 
            && post.category === "workspace" && post.opened_id === null).length;
  
          const eleFinUnopen = posts.filter(post => post.departments === "electric" 
            && post.category === "finals" && post.opened_id === null).length;
  
          const eleReqOpen = posts.filter(post => post.departments === "electric" 
            && post.category === "requirements" && post.opened_id).length;
  
          const eleWorkOpen = posts.filter(post => post.departments === "electric" 
            && post.category === "workspace" && post.opened_id).length;
  
          const eleFinOpen = posts.filter(post => post.departments === "electric" 
            && post.category === "finals" && post.opened_id).length;

          // UNIVERSAL
    const uniReqUnopen = posts.filter(post => post.departments === "universal" 
      && post.category === "requirements" && post.opened_id === null).length;

    const uniWorkUnopen = posts.filter(post => post.departments === "universal" 
      && post.category === "workspace" && post.opened_id === null).length;

    const uniFinUnopen = posts.filter(post => post.departments === "universal" 
      && post.category === "finals" && post.opened_id === null).length;

    const uniReqOpen = posts.filter(post => post.departments === "universal" 
      && post.category === "requirements" && post.opened_id).length;

    const uniWorkOpen = posts.filter(post => post.departments === "universal" 
      && post.category === "workspace" && post.opened_id).length;

    const uniFinOpen = posts.filter(post => post.departments === "universal" 
      && post.category === "finals" && post.opened_id).length;

  return (
    <div>
      {scene && (
        <>
          <TopBox
            title={`Scene ${number} `}
            episodeTitle={`Episode ${episodeTitle}`}
          />
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
          <Button
            className={`float-right py-0 my-2 ${btnStyles.Order} ${btnStyles.Button}`}
            onClick={() => setShowInfo((showInfo) => !showInfo)}
          >
            INFO
          </Button>
          {!showInfo ? "" : <InfoScenePage />}
          {/* links */}
          <div className={` ${styles.Header}`}>
            <div className="d-none d-md-block">
              <Row className={`${styles.ButtonLine} mt-2 mx-3`}>
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                    <Col md={1}>
                      <p
                        className={`py-0 mb-0 ${styles.Button}`}
                        onClick={() => clickScript()}
                      >
                        {" "}
                        Script
                      </p>
                    </Col>
                  )}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                    <Col md={2} className="text-center">
                      <p
                        className={`py-0 mb-0 ${styles.Button}`}
                        onClick={() => handleClickMoods()}
                      >
                        {" "}
                        Moodboards
                      </p>
                    </Col>
                  )}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                    <Col md={2} className="text-center">
                      <p
                        className={`py-0 mb-0 ${styles.Button}`}
                        onClick={() => setShowBreak((showBreak) => !showBreak)}
                      >
                        {" "}
                        Breakdown
                      </p>
                    </Col>
                  )}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                    <Col md={2} className="text-center">
                      <p
                        className={`py-0 mb-0 ${styles.Button}`}
                        onClick={() =>
                          setShowCharactersBG(
                            (showCharactersBG) => !showCharactersBG
                          )
                        }
                      >
                        Characters/BG
                      </p>
                    </Col>
                  )}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                    <Col className="text-center" md={2}>
                      <p
                        className={`py-0 mb-0 ${styles.Button}`}
                        onClick={() => clickStory()}
                      >
                        {" "}
                        Storyboard
                      </p>
                    </Col>
                  )}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                    <Col className="text-center" md={1}>
                      <p
                        className={`py-0 mb-0 ${styles.Button}`}
                        onClick={() => setShowlist((showlist) => !showlist)}
                      >
                        Shotlist
                      </p>
                    </Col>
                  )}
                  {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                <Col className="text-center pr-md-3 pr-lg-0 pl-lg-5" md={1}>
                  <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() =>
                      setShowStoryShot((showStoryShot) => !showStoryShot)
                    }
                  >
                    {" "}
                    Story/Shot
                  </p>
                </Col>
                )}
                <Col className="text-right px-0" md={1}>
                  {currentUser &&
                    currentUser?.groups.length > 0 &&
                    currentUser?.groups[0]?.name !== ("Cast" && 'Crew') && (
                      <PostDropAdminOnly
                      className="float-right"
                        handleEdit={handleEdit}
                        handleDelete={handleDelete}
                      />
                    )}
                </Col>
              </Row>
            </div>
            <div className="d-md-none">
              <Row className={`${styles.ButtonLine} px-0 d-flex align-items-center my-2`}>
                <Col xs={1} ></Col>
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                <Col xs={3} className="text-center">
                  <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() =>
                      setShowCharactersBG(
                        (showCharactersBG) => !showCharactersBG
                      )
                    }
                  >
                    Chars/BG
                  </p>
                </Col>
                )}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                <Col xs={3} className="text-center px-0">
                  <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowBreak((showBreak) => !showBreak)}
                  >
                    {" "}
                    Breakdown
                  </p>
                </Col>
                )}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                <Col xs={3} className="text-center px-0">
                  <p className={`py-0 mb-0 ${styles.Button}`}
                          onClick={() => clickScript()}> Script
                  </p>
                </Col>
                )}
                <Col className="text-center px-0" xs={1}>
                {currentUser &&
                    currentUser?.groups.length > 0 &&
                    currentUser?.groups[0]?.name !== ("Cast" && 'Crew') && (
                  <PostDropAdminOnly
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                  />
                  )}
                </Col>
              </Row>
              <Row>
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                <Col xs={3} className="text-center">
                  <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => handleClickMoods()}
                  >
                    {" "}
                    Moodboards
                  </p>
                </Col>
                )}
                {/* Storyboard */}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                <Col className="pl-4 text-center" xs={3}>
                  <p className={`py-0 mb-0 ${styles.Button}`}
                      onClick={() => clickStory()}> Storyboard
                  </p>
                </Col>
                )}
                {/* Shotlist */}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                <Col className="pl-4 text-center" xs={3}>
                  <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() => setShowlist((showlist) => !showlist)}
                  >
                    Shotlist
                  </p>
                </Col>
                )}
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  currentUser?.groups[0]?.name !== "Cast" && (
                <Col className="text-center" xs={3}>
                  <p
                    className={`py-0 mb-0 ${styles.Button}`}
                    onClick={() =>
                      setShowStoryShot((showStoryShot) => !showStoryShot)
                    }
                  >
                    {" "}
                    Story/Shot
                  </p>
                </Col>
                )}
              </Row>
            </div>
          </div>
          {/* Breakdown CharactersBG Script Moodboards Storyboard Slotlist ShotStory */}
          <div>
            {!showBreak ? (
              ""
            ) : (
              <Breakdown
                id={id}
                scene={scene}
                {...scene}
                setShowBreak={setShowBreak}
                setScene={setScene}
              />
            )}
            {!showCharactersBG ? (
              ""
            ) : (
              <CharactersBG
                id={id}
                setShowCharactersBG={setShowCharactersBG}
              />
            )}
            {/* old script */}
            {/* {!showScript ? (
              ""
            ) : (
              <Script
                scene={scene}
                script={script}
                setShowScript={setShowScript}
                setScene={setScene}/>
            )} */}
            {/* old story */}
            {/* {!showstory ? (
              ""
            ) : (
              <Storyboard
                storyboard={storyboard}
                setShowstory={setShowstory}
                scene={scene}
                setScene={setScene}
              />
            )} */}
            {!showlist ? (
              ""
            ) : (
              <ShotlistPage setShowlist={setShowlist} scene={scene} />
            )}
            {!showStoryShot ? (
              ""
            ) : (
              <div>
              <Row>
                 <Col xs={12} lg={6}>
                  <StoryboardforSList storyboard={storyboard} />
                </Col>
                <Col xs={12} lg={6}>
                  <ShotlistPage setShowlist={setShowStoryShot} scene={scene} />
                </Col>
              </Row>
              <Row className='my-5'>
              <Col xs={2} ></Col>
              <Col xs={8}>
              <hr className={`${styles.Break} mt-0 mb-0 mb-md-1`}/>
              <hr className={`${styles.BreakBlack} my-0`}/>
              </Col>
              </Row>
              </div>
            )}
          </div>
          {/* workspace */}
          <h5
            style={{ textTransform: "uppercase" }}
            className={`mt-1 mb-1 pl-3 py-1 py-md-2 ${styles.SubTitle} text-center`}
          >
            SCENE WORKSHOP
          </h5>
          {/* Guide all */}
          <div>
            <Row>
              <Col>
                {currentUser &&
                  currentUser?.groups.length > 0 &&
                  (currentUser?.groups[0]?.name === "Admin" ||
                    currentUser?.groups[0]?.name === "Superadmin" ||
                    currentUser?.groups[0]?.name === "Admincreative") && (
                    <>
                      {workspace_guide ? (
                        <Button
                          className={`px-sm-4 py-0 mt-1 ${btnStyles.GreyDark} ${btnStyles.Button}`}
                          onClick={() =>
                            setShowGuideEdit((showGuideEdit) => !showGuideEdit)
                          }
                        >
                          Update Guide
                        </Button>
                      ) : (
                        <Button
                          className={` py-0 mt-1 ${btnStyles.GreyDark} ${btnStyles.Button}`}
                          onClick={() =>
                            setShowGuide((showGuide) => !showGuide)
                          }
                        >
                          Update Guide
                        </Button>
                      )}
                    </>
                  )}
                <Button
                  className={`float-right py-0 mt-1 ${btnStyles.GreyDark} ${btnStyles.Button}`}
                  onClick={() =>
                    setShowWorkInfo((showWorkInfo) => !showWorkInfo)
                  }
                >
                  INSTRUCTIONS
                </Button>
              </Col>
            </Row>
            {!showWorkInfo ? (
              ""
            ) : (
              <InfoWorkspace setShowWorkInfo={setShowWorkInfo} />
            )}
            {/* guide forms */}
            <Row className="mb-2">
              <Col md={1}></Col>
              <Col className="mx-0 px-0" xs={12} md={10}>
                {!showGuide ? (
                  ""
                ) : (
                  <WorkspaceGuideForm
                    className="my-2"
                    id={id}
                    number={number}
                    setShowGuide={setShowGuide}
                    setScene={setScene}
                  />
                )}
                {!showGuideEdit ? (
                  ""
                ) : (
                  <WorkspaceGuideEdit
                    className="my-2"
                    id={id}
                    number={number}
                    setShowGuideEdit={setShowGuideEdit}
                    setScene={setScene}
                  />
                )}
              </Col>
            </Row>
            {/* guide */}
            <Row>
              <Col sm={{ span: 8, offset: 2 }}>
                <div className={`pb-0 ${styles.Guide}`}>
                  <p
                    style={{ textTransform: "uppercase" }}
                    className={`pb-0 mb-1 text-center ${styles.GuideTitle}`}
                  >
                    Workshop Guide
                  </p>
                  <div
                    className={`text-center mt-2 px-3`}
                  ><p className={`pb-0 mb-1 text-center ${styles.GuideText}`}>
                    {workspace_guide}{" "}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          {/* Department Images */}
              <div className='mt-0 pt-0'>
                {/* Universal */}
                <Row className={`mt-1`} >
                    <Col xs={2} md={4}  ></Col>
                    <Col className='px-1 px-md-2' xs={8} md={4} >
                    <div className={` ${styles.CardBoxIm} py-2 px-2`}
                      style={{
                        background: `url(${sceneblue8})`,
                        objectFit: "contain", width: '100%', repeat: 'repeat'
                      }}
                      >
                        <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      UNIVERSAL
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-2 pl-md-3 pl-lg-5`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-2 pr-md-3 pr-lg-5`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickUniversalReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{uniReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{uniReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickUniversalWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{uniWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{uniWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickUniversalFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{uniFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{uniFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                    </Col>
                </Row>
                {/* Camera Sound ... */}
                <Row className='px-2'>
                {/* CAMERA 1*/}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${newpur9})`,
                        objectFit: "contain", width: '100%', repeat: 'no-repeat'
                      }}
                        >
                      <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      {/* <span className={`${styles.Camera2}`}>C</span>AMERA */}
                      CAMERA
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq}`} 
                      onClick={() => handleClickCameraReq() }>
                      <Row className='py-0 mt-1'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{camReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{camReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickCameraWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{camWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{camWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickCameraFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{camFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{camFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* SOUND 2 */}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${sceneblue6})`,
                        objectFit: "contain", width: '100%', repeat: 'no-repeat'
                      }}
                      >
                        <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      SOUND
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickSoundReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{souReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{souReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickSoundWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{souWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{souWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickSoundFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{souFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className='d-block d-md-none'> FINALS</p>
                      <p className='d-none d-md-block'> FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{souFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* LOCATION 3*/}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${sceneblue6})`
                      }}
                      >
                        <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      LOCATIONS
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickLocationReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{locReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{locReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickLocationWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{locWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{locWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickLocationFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{locFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className='d-block d-md-none'> FINALS</p>
                      <p className='d-none d-md-block'> FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{locFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* SCRIPT 4*/}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${sceneblue6})`,
                      }}
                      >
                        <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      SCRIPT
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickScriptReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{scrReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{scrReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickScriptWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{scrWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{scrWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickScriptFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{scrFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className='d-block d-md-none'> FINALS</p>
                      <p className='d-none d-md-block'> FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{scrFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* ART 5*/}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${sceneblue6})`
                      }}
                      >
                        <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      ART
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickArtReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{artReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{artReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickArtWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{artWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{artWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickArtFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{artFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className='d-block d-md-none'> FINALS</p>
                      <p className='d-none d-md-block'> FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{artFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* MAKEUP 6 */}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${newpur})`,
                        objectFit: "contain", width: '100%', repeat: 'no-repeat'
                      }}
                      >
                      <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      <span className={`${styles.Camera2}`}>M</span>AKEUP
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickMakeupReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{makReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{makReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickMakeupWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{makWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{makWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickMakeupFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{makFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{makFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* WARDROBE 7 */}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${sceneblue6})`
                      }}
                      >
                        <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      WARDROBE
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickWardrobeReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{warReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{warReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickWardrobeWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{warWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{warWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickWardrobeFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{warFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{warFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* CASTING 8 */}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${sceneblue6})`,
                      }}
                      >
                        <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      CASTING
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickCastingReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{casReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{casReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickCastingWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{casWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{casWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickCastingFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{casFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{casFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* POST/VFX 9 */}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${newpur})`,
                        objectFit: "contain", width: '100%', repeat: 'no-repeat'
                      }}
                      >
                      <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      <span className={`${styles.Camera2}`}>P</span>OST/VFX
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickPostReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{posReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{posReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickPostWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{posWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{posWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickPostFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{posFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{posFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* PRODUCTION 10 */}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${sceneblue6})`
                      }}
                      >
                        <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      PRODUCTION
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickProductionReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{proReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{proReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickProductionWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{proWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{proWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickProductionFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{proFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{proFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* STUNTS 11*/}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${sceneblue6})`
                      }}
                      >
                        <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      STUNTS/SFX
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickStuntsReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{stuReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{stuReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickStuntsWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{stuWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{stuWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickStuntsFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{stuFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{stuFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                {/* ELECTRIC 12 */}
                <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
                      <div className={` ${styles.CardBox2} px-2`}
                      style={{
                        background: `url(${newpur9})`,
                        objectFit: "contain", width: '100%', repeat: 'no-repeat'
                      }}
                      >
                        <Row className='my-2'>
                      <Col>
                      <h5 className={`text-center ${styles.White2} mt-2`} >
                      ELECTRIC/GRIP
                      </h5>
                      </Col>
                      </Row>
                      {/* read */}
                      <Row>
                        <Col xs={6}>
                        <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                        <Col xs={6} >
                        <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
                      </Row>
                      {/* requirements */}
                      <div className={` ${styles.WhiteReq} mt-1`} 
                      onClick={() => handleClickElectricReq() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{eleReqOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
                      <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`${styles.Read} float-left`}>{eleReqUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* workspace */}
                      <div className={` ${styles.WhiteReq} mt-3`}
                      onClick={() => handleClickElectricWor() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{eleWorkOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > WORKSPACE</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{eleWorkUnopen}</p></Col>
                      </Row>
                      </div>
                      {/* Finals */}
                      <div className={` ${styles.WhiteReq} my-3`}
                      onClick={() => handleClickElectricFin() }>
                      <Row className='py-0'>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-right ${styles.Read}`}>{eleFinOpen}</p></Col>
                      <Col xs={8} className={`text-center`}>
                      <p > FINALS</p>
                      </Col>
                      <Col xs={2} className={`text-center px-0`}>
                      <p className={`float-left ${styles.Read}`}>{eleFinUnopen}</p></Col>
                      </Row>
                      </div>
                      </div>
                </Col>
                </Row>
              </div>
        </>
      )}
    </div>
  );
};

export default Scene;
